import { createTheme } from "@material-ui/core/styles";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#e2136e",
      light: "#ebc7d7",
      dark: "#8b1146",
    },

    info: {
      main: "#e2136e",
      light: "#ebc7d7",
      dark: "#8b1146",
    },
  },
});
